import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';
import { lastValueFrom } from 'rxjs';

import { MentionDocument } from '../../data/models/mention.model';

@Injectable({
  providedIn: 'root'
})
export class UpdateMentionService {
  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {}

  _genDefaultHeader() {
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    return headers;
  }

  async updateMention(updateMention: MentionDocument): Promise<MentionDocument> {
    let sectionId = this.common.getSelectedSection().sectionId;
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    let headers = this._genDefaultHeader();
    headers = headers.set('LoginUserId', loginUserId);

    const url = `${apiConfig.uri}/licence/${sectionId}/mention/${updateMention.id}`;

    var result = await lastValueFrom(
      this.httpClient.put<MentionDocument>(url, updateMention, {
        headers: headers
      })
    );
    return result;
  }
}
